import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles(() => ({
  editButton: {
    color: "rgba(0, 0, 0) !important",
    "&:hover": {
      color: "rgba(0, 0, 0) !important",
      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.26) !important",
    },
    "& svg": {
      color: "inherit !important",
    },
  },
  BtnDone: {
    position: "absolute !important",
    top: "80px",
    right: "40px",
    "&.disabled": {
      pointerEvents: "none !important",
      background: "#ccc",
      cursor: "unset",
      "&:hover, &:focus, &:active": {
        background: "#ccc",
      },
    },
  },
  ContainerInfo: {
    position: "relative",
  },
  text: {
    marginLeft: 5,
  },
  infoHeader: {
    display: "flex",
    alignItems: "center",
    "& h3": {
      margin: "0 8px",
    },
  },
  InfoHeight: {
    minHeight: "395px",
    '& div[class="bodyContainer*"]': {
      minHeight: "335px",
    },
  },
  customHeader: {
    display: "flex",
    marginLeft: 18,
    alignItems: "center",
  },
  calendar: {
    display: "flex",
    padding: "0 18px",
    alignItems: "center",
    borderLeft: `1px solid ${theme.color.gray2}`,
    borderRight: `1px solid ${theme.color.gray2}`,
    color: theme.color.gray5,
    fontSize: 14,
    marginRight: 18,
  },
  calendarIcon: {
    width: 18,
    marginRight: 8,
  },
  statusBadge: {
    borderRight: `1px solid ${theme.color.gray2}`,
    paddingRight: "18px",
    marginRight: "18px",
  },
  switchButton: {
    "& span": {
      fontSize: 14,
    },
  },
  infoContainer: {
    marginTop: 10,
    marginBottom: 20,
  },
  informationHeader: {
    marginRight: 18,
    width: "100%",
    "& .about": {
      display: "flex",
      "& .left, & .right": {
        flex: 1,
      },
      "& .left": {
        paddingRight: "10px",
      },
      "& .right": {
        marginLeft: "10px",
      },
      "& table": {
        width: "100%",
        borderSpacing: "0 20px",
      },
      "& .label": {
        color: theme.color.black,
        width: "50%",
        verticalAlign: "top",
      },
      "& .data": {
        color: theme.color.blue,
        fontWeight: "bold",
        width: "50%",
        verticalAlign: "top",
      },
    },
  },
  Low: {
    color: theme.color.red,
  },
  Medium: {
    color: theme.color.orange,
  },
  High: {
    color: theme.color.green,
  },
  modal: {
    display: "flex",
    padding: theme.spacing(1),
    alignItems: "center",
    justifyContent: "center",
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "508px !important",
    },
    "& .MuiDialogActions-spacing": {
      justifyContent: "space-between !important",
    },
  },
  ModalContainer: {
    padding: "0 50px",
    textAlign: "center",
  },
  buttonDelete: {
    "&.disabled": {
      pointerEvents: "none !important",
      background: "#ccc",
      cursor: "unset",
      "&:hover, &:focus, &:active": {
        background: "#ccc",
      },
    },
    marginRight: 40,
  },
}));
